"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_VISUALISER_DEFINITION = void 0;
/**
 * Visualiser tool metadata: gate none, screen only (no handler, no PDF).
 * Registered by HAN-654's ToolRegistry.
 */
exports.PAYMENT_VISUALISER_DEFINITION = {
    key: "payment_visualiser",
    version: 1,
    gate: { placement: "none", fields: [], consentPurposes: ["id_invite"] },
    fulfilment: { screen: true },
    ctaRules: [],
    events: [
        { type: "page_view" },
        { type: "own_terms_applied" },
        { type: "walkthrough_started" },
        { type: "walkthrough_finished" },
        { type: "faq_opened" },
        { type: "invite_sheet_opened" },
        { type: "invite_option_picked" },
        { type: "invite_submitted" },
        { type: "send_it_myself_tapped" },
    ],
};
